<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Skeleton',
});
</script>

<template>
  <div class="flex animate-pulse space-x-4">
    <div class="flex-1 py-1 space-y-3 md:space-y-5">
      <div class="h-12 md:h-14 bg-neutral-200 rounded-4xl" />
      <div class="h-12 md:h-14 bg-neutral-200 rounded-4xl" />
      <div class="space-y-2">
        <div class="w-3/6 h-4 md:h-5 bg-neutral-200 rounded-4xl" />
        <div class="h-4 md:h-5 bg-neutral-200 rounded-4xl" />
        <div class="h-4 md:h-5 bg-neutral-200 rounded-4xl" />
      </div>
      <div class="h-24 md:h-28 bg-neutral-200 rounded-2xl" />
    </div>
  </div>
</template>
